import React, { Component } from 'react';
import styled from 'styled-components';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import SignIn from './User/SignIn'
import Register from './User/Register'
import ForgetPassword from './User/ForgetPassword';
import OldMemberChangePassword from './User/OldMemberChangePassword'
import isEmail from './dev/validation/isEmail';
import withLoginCheck from './HOC/withLoginCheck';
const { REACT_APP_URI = '/' } = process.env

class UserMobile extends Component {
    state = {
    }
    componentDidMount() {
        fetch(`${REACT_APP_URI}/accounts/getToken/`, { credentials: 'include' })
            .then(res => res.json())
            .then(res => this.props.dispatch({ type: 'setToken', token: res.token }))
    }
    render() {
        const { isActive, condition, auth } = this.props.user
        if (auth === 'isSignIn') this.props.history.push('/')
        return (
            <React.Fragment>
                <Container isActive={isActive} isSignIn={condition === 'signIn'}>
                    <Content isRegister={condition === 'register'}>
                        {condition === 'signIn' && <SignIn isEmail={isEmail}/>}
                        {condition === 'register' && <Register />}
                        {condition === 'forgetPassword' && <ForgetPassword />}
                        {condition === 'oldMemberChangePassword' && <OldMemberChangePassword />}
                    </Content>
                </Container>
            </React.Fragment>
        );
    }
}
const mapStateToProps = state => {
    return {
        user: state.User
    }
}
export default withRouter(connect(mapStateToProps)(withLoginCheck(UserMobile)));
const Container = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center; 
    padding: 50px 0;
    background-color: #fafafa;
    border-left: 1px solid #e6e6e6;      
    min-width: 900px;
    @media (max-width: 900px){
        min-width: 320px;
    }      
`
const Content = styled.div`
    position: relative;
    width: 100%;
    min-height: ${props => props.isRegister ? '420px' : '380px'};
    padding: 48px;
`


// WEBPACK FOOTER //
// ./src/UserMobile.js